// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/common/v1/filters.proto (package thru.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Pubkey, Signature, TaPubkey, TsSignature } from "./primitives_pb";
import { file_thru_common_v1_primitives } from "./primitives_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/common/v1/filters.proto.
 */
export const file_thru_common_v1_filters: GenFile = /*@__PURE__*/
  fileDesc("Chx0aHJ1L2NvbW1vbi92MS9maWx0ZXJzLnByb3RvEg50aHJ1LmNvbW1vbi52MSLHAQoGRmlsdGVyEiQKCmV4cHJlc3Npb24YASABKAlCC+BBAbpIBXIDGIAgSACIAQESNwoGcGFyYW1zGAIgAygLMiIudGhydS5jb21tb24udjEuRmlsdGVyLlBhcmFtc0VudHJ5QgPgQQEaTwoLUGFyYW1zRW50cnkSCwoDa2V5GAEgASgJEi8KBXZhbHVlGAIgASgLMiAudGhydS5jb21tb24udjEuRmlsdGVyUGFyYW1WYWx1ZToCOAFCDQoLX2V4cHJlc3Npb24ipAQKEEZpbHRlclBhcmFtVmFsdWUSGwoMc3RyaW5nX3ZhbHVlGAEgASgJQgPgQQFIABIaCgtieXRlc192YWx1ZRgCIAEoDEID4EEBSAASGQoKYm9vbF92YWx1ZRgDIAEoCEID4EEBSAASGAoJaW50X3ZhbHVlGAQgASgSQgPgQQFIABIZCgp1aW50X3ZhbHVlGAUgASgEQgPgQQFIABIbCgxkb3VibGVfdmFsdWUYBiABKAFCA+BBAUgAEjMKDHB1YmtleV92YWx1ZRgHIAEoCzIWLnRocnUuY29tbW9uLnYxLlB1YmtleUID4EEBSAASOQoPc2lnbmF0dXJlX3ZhbHVlGAggASgLMhkudGhydS5jb21tb24udjEuU2lnbmF0dXJlQgPgQQFIABI4Cg90YV9wdWJrZXlfdmFsdWUYCSABKAsyGC50aHJ1LmNvbW1vbi52MS5UYVB1YmtleUID4EEBSAASPgoSdHNfc2lnbmF0dXJlX3ZhbHVlGAogASgLMhsudGhydS5jb21tb24udjEuVHNTaWduYXR1cmVCA+BBAUgAEjoKEGJ5dGVzX2xpc3RfdmFsdWUYCyABKAsyGS50aHJ1LmNvbW1vbi52MS5CeXRlc0xpc3RCA+BBAUgAEjwKEXB1YmtleV9saXN0X3ZhbHVlGAwgASgLMhoudGhydS5jb21tb24udjEuUHVia2V5TGlzdEID4EEBSABCBgoEa2luZCIgCglCeXRlc0xpc3QSEwoGdmFsdWVzGAEgAygMQgPgQQEiOQoKUHVia2V5TGlzdBIrCgZ2YWx1ZXMYASADKAsyFi50aHJ1LmNvbW1vbi52MS5QdWJrZXlCA+BBASKhAQoTQ2VsRmlsdGVyVmFsaWRhdGlvbhInChFhbGxvd2VkX2Z1bmN0aW9ucxgBIAMoCUIM4EEBukgGkgEDEIABEiQKDmFsbG93ZWRfZmllbGRzGAIgAygJQgzgQQG6SAaSAQMQgAISKAoObWF4X2NvbXBsZXhpdHkYAyABKA1CC+BBAbpIBSoDGOgHSACIAQFCEQoPX21heF9jb21wbGV4aXR5QsgBChJjb20udGhydS5jb21tb24udjFCDEZpbHRlcnNQcm90b1ABWkRnaXRodWIuY29tL1VudG8tTGFicy90aHJ1LW5ldC9ncnBjL3BrZy9wcm90by90aHJ1L2NvbW1vbi92MTtjb21tb252MaICA1RDWKoCDlRocnUuQ29tbW9uLlYxugIDVEhVygIOVGhydVxDb21tb25cVjHiAhpUaHJ1XENvbW1vblxWMVxHUEJNZXRhZGF0YeoCEFRocnU6OkNvbW1vbjo6VjFiBnByb3RvMw", [file_buf_validate_validate, file_google_api_field_behavior, file_thru_common_v1_primitives]);

/**
 * Filter represents a CEL-based expression applied to query or stream results.
 *
 * @generated from message thru.common.v1.Filter
 */
export type Filter = Message<"thru.common.v1.Filter"> & {
  /**
   * CEL expression applied server-side. Empty expressions are treated as no-op.
   *
   * @generated from field: optional string expression = 1;
   */
  expression?: string | undefined;

  /**
   * Named parameter bindings for expression parameterization.
   *
   * @generated from field: map<string, thru.common.v1.FilterParamValue> params = 2;
   */
  params: { [key: string]: FilterParamValue };
};

/**
 * Describes the message thru.common.v1.Filter.
 * Use `create(FilterSchema)` to create a new message.
 */
export const FilterSchema: GenMessage<Filter> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_filters, 0);

/**
 * FilterParamValue carries strongly-typed CEL parameter bindings.
 *
 * @generated from message thru.common.v1.FilterParamValue
 */
export type FilterParamValue = Message<"thru.common.v1.FilterParamValue"> & {
  /**
   * @generated from oneof thru.common.v1.FilterParamValue.kind
   */
  kind: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: bytes bytes_value = 2;
     */
    value: Uint8Array;
    case: "bytesValue";
  } | {
    /**
     * @generated from field: bool bool_value = 3;
     */
    value: boolean;
    case: "boolValue";
  } | {
    /**
     * @generated from field: sint64 int_value = 4;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * @generated from field: uint64 uint_value = 5;
     */
    value: bigint;
    case: "uintValue";
  } | {
    /**
     * @generated from field: double double_value = 6;
     */
    value: number;
    case: "doubleValue";
  } | {
    /**
     * @generated from field: thru.common.v1.Pubkey pubkey_value = 7;
     */
    value: Pubkey;
    case: "pubkeyValue";
  } | {
    /**
     * @generated from field: thru.common.v1.Signature signature_value = 8;
     */
    value: Signature;
    case: "signatureValue";
  } | {
    /**
     * @generated from field: thru.common.v1.TaPubkey ta_pubkey_value = 9;
     */
    value: TaPubkey;
    case: "taPubkeyValue";
  } | {
    /**
     * @generated from field: thru.common.v1.TsSignature ts_signature_value = 10;
     */
    value: TsSignature;
    case: "tsSignatureValue";
  } | {
    /**
     * @generated from field: thru.common.v1.BytesList bytes_list_value = 11;
     */
    value: BytesList;
    case: "bytesListValue";
  } | {
    /**
     * @generated from field: thru.common.v1.PubkeyList pubkey_list_value = 12;
     */
    value: PubkeyList;
    case: "pubkeyListValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message thru.common.v1.FilterParamValue.
 * Use `create(FilterParamValueSchema)` to create a new message.
 */
export const FilterParamValueSchema: GenMessage<FilterParamValue> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_filters, 1);

/**
 * BytesList holds a list of byte arrays for multi-value CEL filtering.
 *
 * @generated from message thru.common.v1.BytesList
 */
export type BytesList = Message<"thru.common.v1.BytesList"> & {
  /**
   * @generated from field: repeated bytes values = 1;
   */
  values: Uint8Array[];
};

/**
 * Describes the message thru.common.v1.BytesList.
 * Use `create(BytesListSchema)` to create a new message.
 */
export const BytesListSchema: GenMessage<BytesList> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_filters, 2);

/**
 * PubkeyList holds a list of pubkeys for multi-value CEL filtering.
 *
 * @generated from message thru.common.v1.PubkeyList
 */
export type PubkeyList = Message<"thru.common.v1.PubkeyList"> & {
  /**
   * @generated from field: repeated thru.common.v1.Pubkey values = 1;
   */
  values: Pubkey[];
};

/**
 * Describes the message thru.common.v1.PubkeyList.
 * Use `create(PubkeyListSchema)` to create a new message.
 */
export const PubkeyListSchema: GenMessage<PubkeyList> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_filters, 3);

/**
 * CelFilterValidation describes the validation configuration returned to
 * clients to help them build safe filter expressions.
 *
 * @generated from message thru.common.v1.CelFilterValidation
 */
export type CelFilterValidation = Message<"thru.common.v1.CelFilterValidation"> & {
  /**
   * List of allowed CEL function names for a specific request type.
   *
   * @generated from field: repeated string allowed_functions = 1;
   */
  allowedFunctions: string[];

  /**
   * List of allowed field names accessible to the CEL expression.
   *
   * @generated from field: repeated string allowed_fields = 2;
   */
  allowedFields: string[];

  /**
   * Maximum AST node count permitted for a CEL expression.
   *
   * @generated from field: optional uint32 max_complexity = 3;
   */
  maxComplexity?: number | undefined;
};

/**
 * Describes the message thru.common.v1.CelFilterValidation.
 * Use `create(CelFilterValidationSchema)` to create a new message.
 */
export const CelFilterValidationSchema: GenMessage<CelFilterValidation> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_filters, 4);

